import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { AutenticacionService } from './autenticacion.service';
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import { VigenciasSolicitudesReferencias } from '../_models/vigencias';

@Injectable({
    providedIn: 'root'
})
export class ValidityReferencesService {

  serviceURL = AppSettings.rutServiciosAPL + '/api/vigenciasSolicitudesReferencias';

  constructor( private authHttp: HttpClient, private authenticationService: AutenticacionService ) {
  }

  getAll() {
     return this.authHttp.get( this.serviceURL ).pipe( map( res => res as VigenciasSolicitudesReferencias[] ) );
  }

  getAllEnable() {
     return this.authHttp.get( this.serviceURL + '/enabled' ).pipe( map( res => res as VigenciasSolicitudesReferencias[] ) );
  }

  getById( id: string ) {
     return this.authHttp.get( this.serviceURL + '/' + id  ).pipe( map( res => res as VigenciasSolicitudesReferencias ) );
  }

  add( c: VigenciasSolicitudesReferencias ) {
     c.auditoriaUsuario = this.authenticationService.obtenerIdUsuarioLogueado();
     return this.authHttp.post( this.serviceURL, c ).pipe( map( res => res as VigenciasSolicitudesReferencias ) );
  }

  update( c: VigenciasSolicitudesReferencias ) {
     c.auditoriaUsuario = this.authenticationService.obtenerIdUsuarioLogueado();
     return this.authHttp.put( this.serviceURL , c ).pipe( map( res => res as VigenciasSolicitudesReferencias ) );
  }

  bulk( c: VigenciasSolicitudesReferencias[] ) {
      c.forEach(element => {
         element.auditoriaUsuario = this.authenticationService.obtenerIdUsuarioLogueado();
      });
     return this.authHttp.post( this.serviceURL + '/bulk', c ).pipe( map( res => res as VigenciasSolicitudesReferencias[] ) );
  }
}
